import React, {useState, useEffect, useReducer} from 'react';
import {Icon} from 'antd-mobile-v2';
import Draggable from 'react-draggable';
import {useStore} from '@/store/hooks';
import {observer} from 'mobx-react-lite';
import {isWeiXin, wxInit} from '@utils/weixin';
import {handleError, locationTo, getUser, urlStringToObj} from '@utils/tools';
import {SERVER_FILE_LINK} from '@utils/public';
import {getLocationByTxMap, getCityCode} from '@/utils/getLocation';
import {queryDoctorsthList, requestRcmDoc, queryCityList, requestUserStepDetail} from '@/store/api/home';
import {host} from '@/utils/hostConf';
import {Link} from 'react-router-dom';
import Banner from '@/components/Banner';
import DoctorCard from '@/components/DoctorCard';
import ToolBar from '@/components/ToolBar';
import slogan from '@/assets/images/slogan.png';

import slogan1 from '@/assets/images/slogan1.png';
import hospital from '@/assets/images/hospital.png';
import reservation from '@/assets/images/reservation.png';
import service from '@/assets/images/customer-service.png';
import ImgDz from '@/assets/images/dz.png';
import IconNew from '@/assets/icons/new.png';
import video from '@/assets/images/video.png';
import ImgMini from '@/assets/images/mini-code.jpg';
import './index.less';
import Cookie from 'js-cookie';
const initState = {
  city_no: '',
  cityList: [],
  docVideoList: [], // 请求视频推荐医生
  docRecommendList: [], // 请求推荐医生
  docDoctorsthList: [], // 请求急速问诊
  showQrCode: false,
  dragging: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'update':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default observer(() => {
  let timer = null;
  const {user_id, mobile} = getUser();
  const [scrollNum, setScrollNum] = useState(0);
  const [scrolling, setScrolling] = useState(false);
  const [userStep, setUserStep] = useState({});
  const [showMinCode, setShowMinCode] = useState(false);
  const [state, dispatch] = useReducer(reducer, initState);
  const {city_no, cityList, docVideoList, docRecommendList, docDoctorsthList, showQrCode, dragging} = state;
  useEffect(() => {
    //微信初始化
    if (isWeiXin()) {
      wxInit();
    }
    getLocationByTxMap(
      location => {
        changeData({city_no: getCityCode(location)});
      },
      () => {
        changeData({city_no: '020'});
      }
    );

    fetchUserStepDetail();
    // timer = setInterval(() => {
    //   fetchUserStepDetail();
    // }, 5 * 1000);

    window.addEventListener('scroll', onScroll);

    const getParams = urlStringToObj();
    if (getParams.source) {
      var inFifteenMinutes = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
      Cookie.set('h5_source', getParams.source, {expires: inFifteenMinutes});
    }
    return () => {
      clearInterval(timer);
      timer = null;
    };
  }, []);

  useEffect(() => {
    if (!city_no) return;
    reqCityList();
    queryVideoRcmDoc();
    queryRcmDoc();
    querysthDoc();
  }, [city_no]);

  async function fetchUserStepDetail() {
    if (!user_id) return;
    const {data, code} = await requestUserStepDetail({
      user_id,
      mobile,
    });
    if (code === 200) {
      setUserStep(data);
    }
  }

  //请求视频推荐医生
  async function queryVideoRcmDoc() {
    const params = {
      city_no: +city_no,
      page_no: 1,
      page_size: 4,
      property: 2,
      hold: !city_no,
    };
    const res = await requestRcmDoc(params);
    changeData({docVideoList: res.list});
  }

  //请求推荐医生
  async function queryRcmDoc() {
    const params = {
      city_no: +city_no,
      page_no: 1,
      page_size: 4,
      property: 1,
      hold: !city_no,
    };
    const res = await requestRcmDoc(params);
    changeData({docRecommendList: res.list});
  }
  //请求急速问诊
  async function querysthDoc() {
    const res = await queryDoctorsthList({page_size: 3});
    changeData({docDoctorsthList: res.list});
  }

  async function reqCityList() {
    const [err, res] = await handleError(queryCityList());
    if (!err) {
      changeData({cityList: res.city_list});
    }
  }

  function changeData(data) {
    dispatch({type: 'update', data});
  }

  function onClick() {
    changeData({showQrCode: true});
  }

  function onDrag() {
    changeData({dragging: true});
  }

  function onStop() {
    changeData({dragging: false});
    !dragging && onClick();
  }

  // 实时监听浏览器滚动条状态（页面必须要有滚动状态）
  var topValue = 0, // 上次滚动条到顶部的距离
    interval = null; // 定时器

  function onScroll(e) {
    if (interval == null)
      // 未发起时，启动定时器，1秒1执行
      interval = setInterval(test, 300);
    topValue = document.documentElement.scrollTop;
  }

  function test() {
    // 判断此刻到顶部的距离是否和1秒前的距离相等
    if (document.documentElement.scrollTop == topValue) {
      clearInterval(interval);
      interval = null;
    }
  }

  const onToggleMin = () => {
    setShowMinCode(!showMinCode);
  };

  return (
    <div className="home-page">
      <Draggable onDrag={onDrag} onStop={onStop}>
        <div className="customer-service" onClick={() => alert(1)}>
          <img alt="" className="customer-service-img" src={service} />
        </div>
      </Draggable>
      <div className="home-top">
        <CitySelect
          data={cityList}
          city_no={city_no}
          onSelect={e => {
            let value = e.target.value;
            changeData({city_no: value});
          }}
        />
        <a href="/en/" className="language">
          EN
        </a>
      </div>
      <div className="search-box" onClick={() => locationTo(`/search?=${city_no}`)}>
        <span>搜索医生/疾病/分院/视频看诊</span>
      </div>
      {/*<Banner city_no={city_no} />*/}
      <section className="visit-list">
        <Link className="visit-item" to={`/doctorList?city_code=${city_no}&schedule_date=1&video=1`}>
          <img className="visit-hospital" src={hospital} alt="" />
          <span className="sub-title">当天看诊</span>
          <span className="desc">全国41家分院</span>
        </Link>
        {/*<a className="visit-item ai" href="https://miying.qq.com/guide-h5/home?appid=wxc04ce1d87dcd13cd">
          <img className="visit-ai" src={ImgDz} alt="" />
          <img className="icon-new" src={IconNew} alt="" />
          <span className="sub-title">智能导诊</span>
          <span className="desc">人工智能服务</span>
        </a>*/}
        <Link className="visit-item" to={`/doctorList?city_code=${city_no}&schedule_date=0&video=1`}>
          <img className="visit-reservation" src={reservation} alt="" />
          <span className="sub-title">预约看诊</span>
          <span className="desc">2600+名医坐诊</span>
        </Link>
        <Link className="visit-item" to={`/doctorList?city_code=${city_no}&schedule_date=0&video=2`}>
          <img className="visit-video" src={video} alt="" />
          <span className="sub-title">视频看诊</span>
          <span className="desc">大咖医生等候您</span>
        </Link>
      </section>
      <section className="nav-section">
        <Link className="nav-left" to={'/v2/buyun/list'}>
          {/*<h3>小固会员</h3>*/}
          {/*<h4>多重权益轻松拿</h4>*/}
        </Link>
        <div className="nav-right">
          <Link className="nav-right-top" to={'/doctorList'}>
            {/*{isWeiXin() ? (
              <wx-open-launch-weapp id="launch-btn" username="gh_175555162a08" path="/pages/index/index.html">
                <script type="text/wxtag-template">
                  <div className="action-code" style={{width: '170px', height: '60px'}}></div>
                </script>
              </wx-open-launch-weapp>
            ) : (
              <div className="action-code" onClick={onToggleMin}></div>
            )}*/}
          </Link>
          <div className="nav-right-bottom" onClick={() => locationTo(`/videolist?city_no=${city_no}`)}>
            <h3>即刻视频看诊</h3>
            <h4>十分钟迅速接诊</h4>
          </div>
        </div>
      </section>
      <Column title="名医直播间">
        <div className="videoList">
          <VideoCard tag="1" />
          <VideoCard tag="2" />
        </div>
      </Column>
      <Column title="即刻视频看诊专家" more={city_no ? `/videolist?city_no=${parseInt(city_no)}` : '/videolist'}>
        <div className="portraitList">
          {docDoctorsthList &&
            docDoctorsthList.slice(0, 3).map((item, key) => <PortraitContent key={'portraitList' + key} {...item} />)}
        </div>
      </Column>
      <Column title="视频看诊名医推荐" more={`/v2/doctorList?city_code=${city_no}&video=2&schedule_date=0`}>
        <div className="doctorList">
          {docVideoList.length > 0 &&
            docVideoList.map((item, key) => <DoctorCard key={'doctorList' + key} doctorInfo={item} />)}
        </div>
      </Column>
      <Column title="分院看诊名医推荐" more={`/v2/doctorList?city_code=${city_no}&video=1&schedule_date=0`}>
        <div className="doctorList">
          {docRecommendList.length > 0 &&
            docRecommendList.map((item, key) => <DoctorCard key={'yg' + key} doctorInfo={item} />)}
        </div>
      </Column>
      <Column title="中医未来之星招募" className="future">
        <PictureColumn />
      </Column>
      <img
        className="bottom-slogan"
        src="https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/mobile/web/slogan-bottom.jpg"
        alt=""
      />
      <div className="service-terms">
        <a href={SERVER_FILE_LINK.privacy} target="_blank" rel="noreferrer">
          隐私条款
        </a>{' '}
        &nbsp;
        <a href={SERVER_FILE_LINK.service} target="_blank" rel="noreferrer">
          服务条款
        </a>
      </div>
      <div className="service-terms">
        <p>广州市固生堂岭南中分院有限公司</p>
        <p>Copyright© 固生堂 版权所有</p>
      </div>
      <ToolBar city_no={city_no} />
      {user_id && userStep.step_url ? (
        <div
          className={`user-step step-${userStep.step}`}
          onClick={() => {
            location.href = userStep.step_url;
          }}
        >
          {userStep.step_note}
        </div>
      ) : null}
      {showQrCode && (
        <div className="mask" onClick={() => changeData({showQrCode: false})}>
          <div className="qrcode">
            <img
              className="qrcode-img"
              src="https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/gstzy/images/kefu-qr.png"
              alt="客服"
            />
            <span>长按识别二维码添加客服为好友</span>
          </div>
        </div>
      )}
      {showMinCode && (
        <div className="mask" onClick={onToggleMin}>
          <div className="qrcode">
            <img className="qrcode-img" src={ImgMini} alt="小程序码" />
            <span>长按识别二维码访问微信小程序</span>
          </div>
        </div>
      )}
    </div>
  );
});

//城市选择组件
function CitySelect({data, city_no, onSelect}) {
  return (
    <select className="address" value={city_no} onChange={onSelect}>
      {data &&
        data.map((item, key) => (
          <option key={item.city_id} value={item.city_id} data-code={item.city_id}>
            {item.city_name}
          </option>
        ))}
    </select>
  );
}

//栏目容器
function Column({title, children, more, className = ''}) {
  return (
    <div className={`columnBox ${className}`}>
      <div className="columnTitle">
        {title}
        {more && (
          <div onClick={() => locationTo(more)} data-category={title} data-name={title} className="columnText">
            全部
            <Icon type="right" />
          </div>
        )}
      </div>
      <div className="columnContent">{children}</div>
    </div>
  );
}

//视频卡片
function VideoCard({tag}) {
  let tagData = {
    1: {
      text: '正在直播',
      color: 'linear-gradient(to right, #F58574, #F25C44)',
      avatar: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/gstzy/images/video2.png',
      link: '/lecture?over=2',
    },
    2: {
      text: '直播录像',
      color: 'linear-gradient(to right, #F5AA2B, #FEBB73)',
      avatar: 'https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/gstzy/images/video1.png',
      link: '/lecture?over=1',
    },
  };
  let data = tagData[tag];
  return (
    <div className="videoItem" onClick={() => locationTo(data.link)}>
      <div className="videoTag" style={{background: data.color}}>
        {data.text}
        {tag === '1' && (
          <div className="video-player">
            <span className="video-player_bar video-player_bar1"></span>
            <span className="video-player_bar video-player_bar2"></span>
            <span className="video-player_bar video-player_bar3"></span>
          </div>
        )}
      </div>
      <img alt="" className="avatar" src={data.avatar} />
      <span className="garden"></span>
      <span className="videoText">大咖医生为你讲解治胃病</span>
    </div>
  );
}

function PortraitContent({doctor_name, doctor_id, doctor_img, doctor_position, doctor_title}) {
  // let qrLink = `/qrdoctor?id=${doctor_id}&name=${doctor_name}&title=${doctor_title}`;
  let docLink = `/doctorinfo/${doctor_id}`;
  return (
    <div onClick={() => locationTo(docLink)} className="portraitBox">
      <div>
        <img alt="" className="portrai" src={`${host.dr_img}${doctor_img}`} />
      </div>
      <div className="portraiText">{doctor_name}</div>
      <div className="portraiTxt">
        {doctor_position}
        {doctor_title && doctor_position && '/'}
        {doctor_title}
      </div>
    </div>
  );
}

//招聘内容
function PictureColumn() {
  let url = 'https://www.gstzy.cn/contractus/zp.html';
  return (
    <div className="picture">
      <a href={url} className="imgLeft">
        <img alt="" src="https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/gstzy/images/zhaopin1.png" />
      </a>
      <a href={url} className="imgRight">
        <img alt="" src="https://wx-gstzy.oss-cn-shenzhen.aliyuncs.com/gstzy/images/zhaopin2.png" />
      </a>
    </div>
  );
}
